import React, { useRef } from 'react';

import { withEventScope } from '@repo/event-processor';
import IconChevronLeft from '@repo/ui-icons/IconChevronLeft';
import IconChevronRight from '@repo/ui-icons/IconChevronRight';

import useListScroll from 'components/hooks/useListScroll';

import { ImageTextTile } from '../shared/ImageTextTile';

import {
  cardWidth,
  Wrapper,
  CarouselContainer,
  ItemsWrapper,
  TileWrapper,
  ScrollLeftButton,
  ScrollRightButton,
} from './styles';
import { CarouselItemProps } from './types';

const CarouselScrollableItems: React.FC<CarouselItemProps> = ({
  items,
  gap,
  backgroundColor,
}) => {
  const listRef = useRef<HTMLDivElement>(null);

  const scrollAmount = cardWidth + gap;

  const {
    canScrollLeft,
    canScrollRight,
    updateScrollState,
    scrollLeft,
    scrollRight,
  } = useListScroll(listRef, scrollAmount);

  return (
    <Wrapper>
      <CarouselContainer tabIndex={0}>
        <ItemsWrapper ref={listRef} gap={gap} onScroll={updateScrollState}>
          {items.map(({ image, title, url }, index) => (
            <TileWrapper key={index}>
              <ImageTextTile
                backgroundColor={backgroundColor}
                image={image}
                size="m"
                title={title}
                url={url}
              />
            </TileWrapper>
          ))}
        </ItemsWrapper>
        {canScrollLeft && (
          <ScrollLeftButton align="left" onClick={scrollLeft}>
            <IconChevronLeft color="var(--color-icon-secondary)" size={20} />
          </ScrollLeftButton>
        )}
        {canScrollRight && (
          <ScrollRightButton align="right" onClick={scrollRight}>
            <IconChevronRight color="var(--color-icon-secondary)" size={20} />
          </ScrollRightButton>
        )}
      </CarouselContainer>
    </Wrapper>
  );
};

export default withEventScope(CarouselScrollableItems, {
  module: 'carouselScrollableItems',
});
